import { AEMErrorMessage } from '@com-delta-idp/mnx-skymiles-shared';
import { FullPageErrorMessage } from './full-page-error-message.mock';
import { APIPurchaseErrorMessagesMocks } from './purchase.mocks';

export const ErrorMessages: AEMErrorMessage[] = [
  FullPageErrorMessage,
  APIPurchaseErrorMessagesMocks
];
